export default typeof performance !== "undefined" && performance.now
  ? function clock() {
      return performance.now();
    }
  : function clock() {
      return +new Date();
    };
